import { combineReducers } from '@ngrx/store';
import {
  UserDetailsReducer, SelectedTabReducer,
  HistoryReducer, URLReducer, AddNewReducer, UserPermissionReducer, RequestURLReducer
} from '../user/user.reducer';
import { MapsReducer } from '../map/map.reducer';
import { GraphApiReducer } from '../graph/graph.reducer';
import { LoginReducer } from '../login/login.reducer';
import { CheckInReducer } from '../check-in/check-in.reducer';
import { AssessmentDetailsReducer } from '../assessment/assessment.reducer';
import { ProxyGroupReducer } from '../proxy-group/proxy-group.reducer';
import { CheckInProxyReducer, CheckInProxyGroupReducer } from '../check-in/check-in-proxy.reducer';
import { AdminTemplatesReducer } from '../admin/admin.reducer';
import { SiteRequestReducer, ProxyRequestMembersReducer, ApprovedRequestDetailsReducer, SiteRequestProxyDetailsReducer } from '../site-request/site-request.reducer';

export const Reducers = combineReducers({
  userDetails: UserDetailsReducer,
  maps: MapsReducer,
  graphDetails: GraphApiReducer,
  login: LoginReducer,
  checkIn: CheckInReducer,
  proxyGroup: ProxyGroupReducer,
  proxyCheckIn: CheckInProxyReducer,
  assessmentDetails: AssessmentDetailsReducer,
  selectedTab: SelectedTabReducer,
  isHistory: HistoryReducer,
  previousUrl: URLReducer,
  addNew: AddNewReducer,
  proxyGroupCheckIn: CheckInProxyGroupReducer,
  adminTemplates: AdminTemplatesReducer,
  userPermission: UserPermissionReducer,
  siteRedinessMatrix: SiteRequestReducer,
  proxyRequestMembers: ProxyRequestMembersReducer,
  approvedRequestData: ApprovedRequestDetailsReducer,
  siteRequestProxyDetails: SiteRequestProxyDetailsReducer,
  requestUrl: RequestURLReducer
});
